import * as Autosuggest from 'react-autosuggest';
import * as React from 'react';

import { AppState } from 'common/models/AppState';
import { Member } from 'common/api/models/Member';
import { MemberApi } from 'common/api/resources/MemberApi';

export interface FormAutosuggestMemberProps {
  id: string;
  autoFocus?: boolean;
  appState: AppState;
  onChange: (field: string, id: string) => void;
  type?: string;
}
export interface FormAutosuggestMemberState {
  value: string;
  userSuggestions: Member[];
  orgSuggestions: Member[];
  isSuggestOpen: boolean;
}
interface Suggestion {
  id: string;
  type: string;
  name: string;
}
export class FormAutosuggestMember extends React.Component<FormAutosuggestMemberProps, FormAutosuggestMemberState> {
  state: FormAutosuggestMemberState = { userSuggestions: [], orgSuggestions: [], isSuggestOpen: false, value: '' };

  isSearchMatch(queryWords: string[], searchString: string): boolean {
    for (let word of queryWords) {
      if (searchString.indexOf(word) === -1) {
        return false;
      }
    }
    return true;
  }

  handleSuggestionsFetchRequested = (value: any) => {
    let query = value.value.toLowerCase();
    if (!this.props.type || this.props.type === 'user') {
      MemberApi.findMembers({ q: query + ' type:user', limit: 5 }).then(res => {
        this.setState({ userSuggestions: res.data });
      });
    }
    if (!this.props.type || this.props.type === 'org') {
      MemberApi.findMembers({ q: query + ' type:org', limit: 5 }).then(res => {
        this.setState({ orgSuggestions: res.data });
      });
    }
  };

  handleSuggestionsClearRequested = () => {
    this.setState({ userSuggestions: [], orgSuggestions: [] });
  };

  handleSuggestionSelected = (event: React.FormEvent<any>, data: Autosuggest.SuggestionSelectedEventData<any>) => {
    event.preventDefault();
    if (data.suggestion && data.suggestion.id) {
      this.props.onChange(this.props.id, data.suggestion.id);
      this.setState({ value: '' });
    }
  };

  handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ value: e.target.value !== undefined ? e.target.value : '' });
  };

  shouldRenderSuggestions(value: string) {
    return true;
  }

  getSuggestionValue = (suggestion: string) => {
    return suggestion;
  };

  renderSuggestion = (suggestion: Suggestion) => {
    return <div>{suggestion.name}</div>;
  };

  render() {
    let placeholder = 'Type the name of a user or organization';
    if (this.props.type === 'user') {
      placeholder = 'Type the name of a user';
    } else if (this.props.type === 'org') {
      placeholder = 'Type the name of an organization';
    }
    const inputProps = {
      value: this.state.value,
      onChange: this.handleChangeInput,
      autoFocus: this.props.autoFocus,
      placeholder: placeholder,
    };

    let suggestions = this.state.orgSuggestions
      .map(o => {
        return { name: o.name, id: o.id! };
      })
      .concat(
        this.state.userSuggestions.map(u => {
          return { name: u.firstName + ' ' + u.lastName + ' (' + u.email + ')', id: u.id! };
        })
      );

    return (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
        onSuggestionSelected={this.handleSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        inputProps={inputProps}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/form/FormAutosuggestMember.tsx